import _asyncToGenerator from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/regenerator/index.js";
import { EventEmitter } from "events";
import { safeJsonParse, safeJsonStringify } from "@walletconnect/safe-json";
import { formatJsonRpcError, isReactNative, isWsUrl, isLocalhostUrl, parseConnectionError } from "@walletconnect/jsonrpc-utils";
import { truncateQuery, resolveWebSocketImplementation, hasBuiltInWebSocket } from "./utils";
var EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
var WS = resolveWebSocketImplementation();
export var WsConnection = /*#__PURE__*/function () {
  function WsConnection(url) {
    _classCallCheck(this, WsConnection);

    this.url = url;
    this.events = new EventEmitter();
    this.registering = false;

    if (!isWsUrl(url)) {
      throw new Error("Provided URL is not compatible with WebSocket connection: ".concat(url));
    }

    this.url = url;
  }

  _createClass(WsConnection, [{
    key: "connected",
    get: function get() {
      return typeof this.socket !== "undefined";
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.registering;
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.url;
                _context.next = 3;
                return this.register(url);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  if (typeof _this.socket === "undefined") {
                    reject(new Error("Connection already closed"));
                    return;
                  }

                  _this.socket.onclose = function (event) {
                    _this.onClose(event);

                    resolve();
                  };

                  _this.socket.close();
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload, context) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof this.socket === "undefined")) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return this.register();

              case 3:
                this.socket = _context3.sent;

              case 4:
                try {
                  this.socket.send(safeJsonStringify(payload));
                } catch (e) {
                  this.onError(payload.id, e);
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "register",
    value: function register() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      if (!isWsUrl(url)) {
        throw new Error("Provided URL is not compatible with WebSocket connection: ".concat(url));
      }

      if (this.registering) {
        var currentMaxListeners = this.events.getMaxListeners();

        if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) {
          this.events.setMaxListeners(currentMaxListeners + 1);
        }

        return new Promise(function (resolve, reject) {
          _this2.events.once("register_error", function (error) {
            _this2.resetMaxListeners();

            reject(error);
          });

          _this2.events.once("open", function () {
            _this2.resetMaxListeners();

            if (typeof _this2.socket === "undefined") {
              return reject(new Error("WebSocket connection is missing or invalid"));
            }

            resolve(_this2.socket);
          });
        });
      }

      this.url = url;
      this.registering = true;
      return new Promise(function (resolve, reject) {
        var opts = !isReactNative() ? {
          rejectUnauthorized: !isLocalhostUrl(url)
        } : undefined;
        var socket = new WS(url, [], opts);

        if (hasBuiltInWebSocket()) {
          socket.onerror = function (event) {
            var errorEvent = event;
            reject(_this2.emitError(errorEvent.error));
          };
        } else {
          socket.on("error", function (errorEvent) {
            reject(_this2.emitError(errorEvent));
          });
        }

        socket.onopen = function () {
          _this2.onOpen(socket);

          resolve(socket);
        };
      });
    }
  }, {
    key: "onOpen",
    value: function onOpen(socket) {
      var _this3 = this;

      socket.onmessage = function (event) {
        return _this3.onPayload(event);
      };

      socket.onclose = function (event) {
        return _this3.onClose(event);
      };

      this.socket = socket;
      this.registering = false;
      this.events.emit("open");
    }
  }, {
    key: "onClose",
    value: function onClose(event) {
      this.socket = undefined;
      this.registering = false;
      this.events.emit("close", event);
    }
  }, {
    key: "onPayload",
    value: function onPayload(e) {
      if (typeof e.data === "undefined") return;
      var payload = typeof e.data === "string" ? safeJsonParse(e.data) : e.data;
      this.events.emit("payload", payload);
    }
  }, {
    key: "onError",
    value: function onError(id, e) {
      var error = this.parseError(e);
      var message = error.message || error.toString();
      var payload = formatJsonRpcError(id, message);
      this.events.emit("payload", payload);
    }
  }, {
    key: "parseError",
    value: function parseError(e) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.url;
      return parseConnectionError(e, truncateQuery(url), "WS");
    }
  }, {
    key: "resetMaxListeners",
    value: function resetMaxListeners() {
      if (this.events.getMaxListeners() > EVENT_EMITTER_MAX_LISTENERS_DEFAULT) {
        this.events.setMaxListeners(EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
      }
    }
  }, {
    key: "emitError",
    value: function emitError(errorEvent) {
      var error = this.parseError(new Error((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.message) || "WebSocket connection failed for host: ".concat(truncateQuery(this.url))));
      this.events.emit("register_error", error);
      return error;
    }
  }]);

  return WsConnection;
}();
export default WsConnection;